import { useEffect, useState, Fragment } from 'react';

import {
  Grid,
  Paper,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from '@material-ui/core';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import BlockIcon from '@material-ui/icons/Block';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import HelpIcon from '@material-ui/icons/Help';
import InfoIcon from '@material-ui/icons/Info';
import PersonIcon from '@material-ui/icons/Person';
import NoteIcon from '@material-ui/icons/Note';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { getExpenses, updateExpense } from '../../services/expenses.service';
import { BackdropComponent } from '../commons/backdrop/backdrop.component';
import { has } from '../../services/summarize.service';

export const ExpensesComponent = () => {

  const history = useHistory();

  const { enqueueSnackbar } = useSnackbar();

  const [pickedDate, setPicketDate] = useState(new Date());

  const [expenses, setExpenses] = useState([]);

  const [open, setOpen] = useState(false);

  const [selectedExpense, setSelectedExpense] = useState();

  const [cancelReason, setCancelReason] = useState('');

  const [view, setView] = useState(false);

  const [loading, setLoading] = useState(true);

  const handleDateChange = (date) => {
    setPicketDate(date);
    getExpensesItems(date);
  }

  const getExpensesItems = async (date) => {
    const expensesItems = await getExpenses(date);
    setExpenses(expensesItems);
    setLoading(false);
  }

  useEffect(() => {
    getExpensesItems(pickedDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setOpen(false);
  }

  const handleViewClose = () => {
    setView(false);
  }

  const handleView = (expense) => {
    setSelectedExpense(expense);
    setView(true);
  }

  const handleCanceled = (expense) => {
    setSelectedExpense(expense);
    setOpen(true);
  }

  const cancelExpense = async (expense) => {
    const updated = {
      ...expense,
      canceled: true,
      description: cancelReason
    };
    await updateExpense(expense.id, updated);
    setExpenses(expenses.map(exp => exp.id === expense.id ? updated : exp));
    enqueueSnackbar('Gasto cancelado', {
      variant: 'success',
      resumeHideDuration: 3000,
      anchorOrigin:
        { horizontal: 'right', vertical: 'bottom' },
    });
    setOpen(false);
  }

  return loading ? (
    <BackdropComponent />
  ) : (
    <Fragment>
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={8}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => history.push('/expenses/new')}
                disabled={!has('EXPENSES::CREATE')}
              >
                Añadir gasto
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker format="dd/MM/yyyy" value={pickedDate} onChange={handleDateChange} />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TableContainer component={Paper}>
                <Table aria-label="ventas">
                  <TableHead>
                    <TableRow>
                      <TableCell>Producto</TableCell>
                      <TableCell>Cantidad</TableCell>
                      <TableCell align="right">Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {expenses
                      .map((expense, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            {expense.product}
                          </TableCell>
                          <TableCell>
                            ${expense.quantity}
                          </TableCell>
                          <TableCell align="right">
                            <Grid container justifyContent="flex-end" spacing={1}>
                              <Grid item>
                                <IconButton
                                  aria-label="view"
                                  onClick={() => handleView(expense)}
                                  disabled={!has('EXPENSES::DETAILS')}
                                >
                                  <InfoIcon fontSize="small" />
                                </IconButton>
                              </Grid>
                              <Grid item>
                                <IconButton
                                  aria-label="edit"
                                  disabled={expense.canceled || !has('EXPENSES::EDIT')}
                                  onClick={() => history.push(`/expenses/${expense.id}/edit`)}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Grid>
                              <Grid item>
                                <IconButton
                                  aria-label="delete"
                                  disabled={expense.canceled || !has('EXPENSES::CANCEL')}
                                  onClick={() => handleCanceled(expense)}
                                >
                                  <BlockIcon fontSize="small" />
                                </IconButton>
                              </Grid>
                            </Grid>
                          </TableCell>
                        </TableRow>
                      ))}
                    {expenses.length === 0 && (
                      <Typography align="center" variant="body1">
                        No hay gastos
                      </Typography>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="cancel-dialog"
        aria-describedby="cancel-dialog-description"
        fullWidth={true}
        maxWidth={'sm'}

      >
        <DialogTitle id="cancel-dialog">
          Cancelar gasto
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="cancel-dialog-description">
            ¿Deseas cancelar el gasto por ${selectedExpense?.quantity}?
          </DialogContentText>
          <TextField
            id="cancelReason"
            label="Razón de la cancelación"
            multiline
            rows={4}
            placeholder="Escribe una breve descripción por la cuál se cancela el gasto"
            variant="outlined"
            onChange={(event) => setCancelReason(event.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            Cerrar
          </Button>
          <Button
            onClick={() => cancelExpense(selectedExpense)}
            color="secondary"
            autoFocus
            disabled={!cancelReason}
          >
            Cancelar gasto
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={view}
        onClose={handleViewClose}
        aria-labelledby="view-dialog"
        aria-describedby="view-dialog-description"
        fullWidth={true}
        maxWidth={'sm'}

      >
        <DialogTitle id="view-dialog">
          Detalles del gasto
        </DialogTitle>
        <DialogContent>
          <List>
            <ListItem>
              <ListItemIcon>
                <CalendarTodayIcon />
              </ListItemIcon>
              <ListItemText primary={selectedExpense?.date} />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <InfoIcon />
              </ListItemIcon>
              <ListItemText primary={selectedExpense?.product} />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <MonetizationOnIcon />
              </ListItemIcon>
              <ListItemText
                primary={`$${selectedExpense?.quantity}`}
              />
            </ListItem>
            <Divider />
            {selectedExpense?.canceled && (
              <Fragment>
                <ListItem>
                  <ListItemIcon>
                    <HelpIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Cancelado"
                  />
                </ListItem>
                <Divider />
              </Fragment>
            )}
            <ListItem>
              <ListItemIcon>
                <NoteIcon />
              </ListItemIcon>
              <ListItemText primary={selectedExpense?.description || 'Sin descripción'} />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <PersonIcon />
              </ListItemIcon>
              <ListItemText primary={`Registrado por: ${selectedExpense?.worker}`} />
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewClose}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}